import styled from 'styled-components';
import { Stack } from '@mui/system';
import { TextInput } from '@shared/inputs/TextInput';
import { colorTheme } from '@styles/muiTheme';

export const CommentBox = styled(TextInput)`
  display: block;
  border: none;
  outline: none;
  width: 100%;
  resize: none;
  border-bottom: 1px solid #e0e0e0;
	.MuiInputBase-inputMultiline  {
    font-size: 14px;
    color: ${colorTheme.palette.secondary.contrastText};
	}
`;

export const AddCommentBlock = styled.div`
  display: flex;
  padding: 5px 2px 10px 10px; 
  background: #fff;
  align-items: center;
  justify-content: center;

  button {
    flex: 1;
  }
`;

export const SearchBlock = styled.div`
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e0e0e1;
  margin-bottom: 5px;

  input {
    flex: 1;
  }
`;

export const FilterItem = styled.div<{ isDealTabSelected: boolean, selected?: boolean }>`
  font-size: 13px;
  padding: 3px 8px;
  font-weight: 600;
  border-radius: 15px;

  background: ${({ isDealTabSelected, selected, theme: { palette } }) => (isDealTabSelected && selected ? palette.success.main : (selected && palette.primary.light))};
  color: ${({ selected, theme: { palette } }) => (selected && palette.common.white)};

  &:hover {
    cursor: pointer;
    background: ${({ isDealTabSelected, selected, theme: { palette } }) => (isDealTabSelected && selected ? palette.success.dark : (selected ? palette.primary.main : palette.grey[400]))};
  }
`;

export const FilterFieldWrapper = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  width: 100%;
`;

export const CommentWrapper = styled.div<{ color: string }>`
  display: flex;
  padding: 2px;
  font-size: 14px;
  gap: 7px;
  word-wrap: break-word;
  flex-direction: column;
  margin-bottom: 10px;
  border: 0.5px solid ${({ color, theme: { palette } }) => color || palette.primary.light};
  border-radius: 4px;
  border-left: 6px solid ${({ color, theme: { palette } }) => color || palette.primary.light};
  background-color: ${({ color, theme: { palette } }) => `${color}15` || `${palette.primary.light}15`};
`;

export const CommentHeader = styled(Stack)`
  width: 100%; 
  padding-left: 6px;
  padding-right: 2px;
`;